"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("../types/enums/events");
exports.UPCOMING_EVENT_STATUSES = [events_1.EventStatus.SCHEDULED, events_1.EventStatus.STARTED];
exports.PAST_EVENT_STATUSES = [events_1.EventStatus.ENDED, events_1.EventStatus.CANCELED];
exports.WIX_FEE_RATE = 0.025;
